export default __webpack_public_path__ + "9ab1275.png";